import React from "react";
import { AlertTriangle, X, Mail, Shield } from "lucide-react";

const UserDeleteModal = ({ user, onConfirm, onCancel, isLoading = false }) => {
  if (!user) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="rounded-full bg-red-100 p-2">
              <AlertTriangle className="text-red-600" size={20} />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Remove Access</h3>
              <p className="text-sm text-gray-500">This action cannot be undone</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-full p-2 text-gray-500 hover:bg-gray-100"
            aria-label="Close modal"
            disabled={isLoading}
          >
            <X size={16} />
          </button>
        </div>

        <div className="space-y-4 px-6 py-5">
          <p className="text-sm text-gray-600">
            Are you sure you want to revoke access for this administrator? They will no longer be
            able to sign into the BeanBot admin console.
          </p>

          <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
            <p className="text-base font-semibold text-gray-900">{user.name || "Unnamed admin"}</p>
            <div className="mt-2 flex items-center gap-2 text-sm text-gray-600">
              <Mail size={16} />
              <span>{user.email}</span>
            </div>
            {user.role?.name && (
              <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                <Shield size={16} />
                <span>{user.role.name}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-gray-200 px-6 py-4 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-lg bg-red-600 px-5 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            disabled={isLoading}
          >
            {isLoading ? "Removing..." : "Remove User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteModal;
